<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">NetBase Theme Selection</p>
            <b-field>
                <b-input rounded v-model="searchName" placeholder="search..." icon="search"></b-input>
            </b-field>
        </header>
        <section class="modal-card-body">
            <div class="np-theme-container">
                <b-notification type="is-danger" v-if="errorMessage" :closable="false">
                    {{ errorMessage }}
                </b-notification>
                <span class="icon is-small nb-theme-loading" v-if="isLoading">
                    <i class="fas fa-spinner fa-pulse"></i>&nbsp;Loading Themes...
                </span>
                <ul>
                    <li
                        v-for="theme in filteredThemes"
                        :key="theme.themeId"
                        class="nb-theme-item"
                        @click="selectTheme(theme)"
                    >
                        {{theme.name}}
                    </li>
                </ul>
            </div>
        </section>
        <footer class="modal-card-foot">
            <button type="button" class="button" @click="close">Close</button>
        </footer>
    </div>
</template>

<script>
import NetBaseService from '@/services/netbase-service.js';

export default {
    name: 'NetBaseThemeSelection',
    data () {
        return {
            themes: [],
            errorMessage: '',
            isLoading: true,
            searchName: '',
            selectedTheme: null
        };
    },
    created () {
        let userId = localStorage.getItem('userId');
        let isNetBaseAuthenticated = localStorage.getItem(
            'isNetBaseAuthenticated'
        );

        // localstorage only stores strings:  https://stackoverflow.com/questions/3263161/cannot-set-boolean-values-in-localstorage
        if (isNetBaseAuthenticated === 'true') {
            NetBaseService.getThemes(userId)
                .then(response => {
                    this.themes = response.data;
                })
                .catch(error => {
                    this.errorMessage = error.message;
                })
                .finally(() => {
                    this.isLoading = false;
                });
        } else {
            this.errorMessage = 'NetBase has not been authenticated';
            this.isLoading = false;
        }
    },
    methods: {
        selectTheme (theme) {
            this.$emit('themeSelected', theme);
            this.$parent.close();
        },
        close () {
            this.$parent.close();
        }
    },
    computed: {
        filteredThemes () {
            return this.themes.filter(theme => {
                return theme.name
                    .toString()
                    .toLowerCase()
                    .includes(this.searchName.toLowerCase());
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.np-theme-container {
    min-height: 250px;

    .nb-theme-item {
        padding: 5px;
        text-overflow: ellipsis;
        overflow: hidden;
        display: inline-block;
        white-space: nowrap;
        width: 100%;
        vertical-align: middle;

        &:hover {
            cursor: pointer;
            background-color: $primary;
            color: $primary-invert;
        }
    }

    .nb-theme-item-desc {
        font-size: 12px;
        font-style: italic;
        color: $text-light;
    }

    .nb-theme-loading {
        text-align: center;
        width: 100%;
    }
}
</style>
